<template>
  <div class="submitResult" :v-loading="loading">
    <div class="submitResultButton">
      <el-radio-group
        v-model="tabPosition"
        size="small"
        style="margin-bottom: 20px"
      >
        <el-radio-button label="已提交"
          >已提交（{{ homeworkDetail.commitCount }}）</el-radio-button
        >
        <el-radio-button label="未提交"
          >未提交（{{ homeworkDetail.unCommitCount }}）</el-radio-button
        >
      </el-radio-group>
      <el-button type="primary" @click="exportExcel">导出</el-button>
    </div>

    <div v-if="tabPosition == '已提交'">
      <div
        v-for="(item, index) in homeworkDetail.commitPersons"
        :key="index"
        class="submitResult_person_box"
      >
        <div class="flex-starts">
          <img class="submitResult_detail_img" :src="item.studentHeadPic" />
          <div>
            <div>{{ item.studentName }}</div>
            <div class="font-small">{{ item.createTime }}</div>
          </div>
        </div>
        <div class="submitResult_detail_data">
          <el-button size="small" @click="toHomeworkQuestion(item.studentId)"
            >客观题共{{ item.questionNum }}题，错误{{ item.wrongNum }}题，未做{{
              item.emptyNum
            }}题，正确率{{
              (
                ((item.questionNum - item.wrongNum - item.emptyNum) /
                  item.questionNum) *
                100
              ).toFixed(1)
            }}%</el-button
          >
        </div>
      </div>
    </div>

    <div
      v-if="tabPosition == '未提交'"
      class="submitResult_unCommitPersons_box"
    >
      <div
        v-for="(item, index) in homeworkDetail.unCommitPersons"
        :key="index"
        class="submitResult_unCommitPersons_item"
      >
        <div class="flex-starts">
          <img class="submitResult_detail_img" :src="item.studentHeadPic" />
          <div>
            <div>{{ item.studentName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeworkQuestion from './homeworkQuestion';
export default {
  components: { homeworkQuestion },
  data () {
    return {
      loading: true,
      examCardDialog: false,
      tabPosition: "已提交",
      homeworkDetail: {},
      homeworkQuestionData: {
        id: null,
        studentId: null
      }
    };
  },
  props: {
    homeworkId: null,
  },
  computed: {},
  created () { },
  methods: {
    getHomeworkDetailById () {
      this.loading = true;
      this.api.homework
        .getHomeworkDetailById({ id: this.homeworkId })
        .then((result) => {
          if (result.success) {
            this.homeworkDetail = result.data;
            this.loading = false;
          } else {
            this.$message.error(result.message);
            this.loading = false;
          }
        });
    },


    toHomeworkQuestion (id) {
      this.homeworkQuestionData.id = this.homeworkId;
      this.homeworkQuestionData.studentId = id;
      this.$emit("examCardDialogChange", this.homeworkQuestionData)
    },
    // 导出
    exportExcel () {
      this.loading = true;
      this.api.homework
        .exportExcel({ id: this.homeworkId, commitPersons: this.homeworkDetail.commitPersons, unCommitPersons: this.homeworkDetail.unCommitPersons })
        .then((result) => {
          if (result.code == 200) {
            if (result.data.indexOf("https") == -1) {
              var url = result.data.replace("http", "https");
            }
            window.location.href = url
            // window.open(url)
          } else {
            this.$message.error(result.message);
            // this.loading = false;
          }
        });
    },
  },
  mounted () {
    this.getHomeworkDetailById();
  },
  watch: {},
};
</script>

<style lang="less" rel="stylesheet/less">
.submitResult {
  height: calc(100vh - 80px);
  overflow-y: auto;
  padding: 0 20px 20px 20px;
}

.submitResult_detail_box {
  border: 1px solid #ccc;
  padding: 10px;
}
.submitResult_detail_content {
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
.submitResult_detail_button {
  width: 100%;
  margin-top: 20px;
}
.submitResult_detail_img {
  height: 40px;
  width: 42px;
  border-radius: 50%;
  margin-right: 10px;
}
.submitResult_detail_data {
  margin-top: 10px;
  width: 300px;
}
.submitResult_person_box {
  margin-bottom: 20px;
}
.submitResult_unCommitPersons_box {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.submitResult_unCommitPersons_item {
  margin-right: 20px;
  margin-bottom: 20px;
  min-width: 80px;
}
.submitResultButton {
  display: flex;
  justify-content: space-between;
  height: 32px;
  .el-button {
    padding: 6px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/submitResult.vue